import {ValidationStepConfig} from 'src/types/form';
import HighSchoolInstitutionStep from './high-school-institution-step';
import {RegistrationSteps} from 'src/types/enums';
import onControlledSubmit from './onControlledSubmit';
import {CurrentInstitutionForm, OnboardingActions} from 'src/types/onboarding';
import validateInstitutionStep from '../../../../../shared/student/registration/validations/validate-institution-step';

export default HighSchoolInstitutionStep;

export const InstitutionStepConfig: ValidationStepConfig<
  CurrentInstitutionForm,
  OnboardingActions
> = {
  key: RegistrationSteps.INSTITUTION,
  onControlledSubmit,
  Component: HighSchoolInstitutionStep,
  validate: validateInstitutionStep,
};
